import classnames from "classnames";
import SimpleErrorMessage from "components/InputsMex/containers/SimpleErrorMessage";
import { inputNumericoEnteros } from "components/InputsMex/validaciones";
import useCustomRef from "hooks/useCustomRef";
import { AutoComplete } from "primereact/autocomplete";
import { Dropdown } from "primereact/dropdown";
import React, { useMemo } from "react";
import { Controller, useFormContext } from "react-hook-form";
import NumberFormat from "react-number-format";
import Select from "react-select";

export const SimpleCheckBox = ({
  name,
  label,
  rules = {},
  defaultValue = false,
  id,
  type = "normal",
}) => {
  return (
    <div className={"row"}>
      <Controller
        name={name}
        defaultValue={defaultValue}
        rules={rules}
        render={({ value, onChange }) => (
          <div className='col-1' style={{ marginRight: "-1em" }}>
            <input
              type='checkbox'
              id={id}
              className='chek-terminos'
              checked={value}
              onChange={(evt) => {
                onChange(evt.target.checked);
              }}
            />
            {type === "slide" && <label for={name} className='check-type-slide'></label>}
          </div>
        )}
      />
      <div className='col-11'>
        <label for={name} className='disclaimers-auto'>
          {label}
          <br></br>
          <SimpleErrorMessage name={name} />
        </label>
      </div>
    </div>
  );
};

//Check box for Pymes
export const SimpleCheckBoxB = ({
  name,
  label,
  rules = {},
  defaultValue = false,
  id,
  type = "normal",
  fontSize = "1em",
  disabled = false,
}) => {
  return (
    <div className='d-flex'>
      <Controller
        name={name}
        defaultValue={defaultValue}
        rules={rules}
        render={({ value, onChange }) => (
          <div className='my-auto containerCheckH '>
            <input
              type='checkbox'
              id={id}
              className='chek-terminos my-auto mr-2'
              disabled={disabled}
              checked={value}
              onChange={(evt) => {
                onChange(evt.target.checked);
              }}
            />
            {type === "slide" && <label htmlFor={name} className=' checkmarkH '></label>}
          </div>
        )}
      />
      <div className='d-flex'>
        <label htmlFor={name} className='my-auto checkmarkH' style={{ fontSize }}>
          {label}
          <br></br>
          <SimpleErrorMessage name={name} />
        </label>
      </div>
    </div>
  );
};

export const SimpleCheckBoxA = ({
  name,
  label,
  rules = {},
  defaultValue = false,
  id,
  type = "normal",
  fontSize = "1em",
  disabled = false,
  onClick = () => { },
}) => {
  return (
    <div className='d-flex'>
      <Controller
        name={name}
        defaultValue={defaultValue}
        rules={rules}
        render={({ value, onChange }) => (
          <label className='containerCheckH '>
            {label}
            <input
              type='checkbox'
              checked={value}
              onChange={(evt) => {
                onChange(evt.target.checked);
                evt.target.checked && onClick();
              }}
            />
            <span className='checkmarkH'></span>
          </label>
        )}
      />
    </div>
  );
};

//CheckBox hogar Flex
export const SimpleCheckBoxFlex = ({
  name,
  label,
  rules = {},
  defaultValue = false,
  fullValue = false,
  onClick = () => { },
}) => {
  return (
    <div className='d-flex'>
      <Controller
        name={name}
        defaultValue={defaultValue}
        rules={rules}
        render={({ value, onChange }) => (
          <React.Fragment>
            <input
              type='checkbox'
              checked={value}
              className='align-self-baseline'
              id={name}
              onChange={(evt) => {
                onChange(evt.target.checked);
              }}
            />
            <label
              className='containerCheckH font-17px align-self-baseline'
              htmlFor={name}>
              {label}
            </label>
          </React.Fragment>
        )}
      />
    </div>
  );
};

export const TextInput = ({
  rules,
  inputProps,
  extrasClasses,
  hideArrows = false,
  defaultValue = null,
  disabled = false,
  prefix = "",
  align = "left",
  onChangeFn = () => { },
  numerico = false,
  evaluateDefaultValue,
  evaluateValue,
  customPlaceHolder
}) => {
  const { register, control } = useFormContext();
  const { focusRef, setRef } = useCustomRef(null);

  const memoProps = useMemo(() => {
    if (inputProps.isNumberInt) {
      const newInputProps = {
        ...inputProps,
        type: "number",
        onKeyDown: inputNumericoEnteros,
      };
      delete newInputProps.isNumberInt;

      return newInputProps;
    }
    return inputProps;
  }, [inputProps]);

  return (
    <Controller
      control={control}
      name={inputProps.name}
      rules={rules}
      defaultValue={defaultValue}
      onFocus={focusRef}
      render={({ onChange, value, ref }) => {
        return (
          <React.Fragment>
            {numerico && (
              <NumberFormat
                defaultValue={evaluateDefaultValue ? evaluateDefaultValue(defaultValue) : defaultValue}
                allowNegative={false}
                thousandSeparator={true}
                decimalScale='2'
                disabled={disabled}
                readOnly={disabled}
                prefix={prefix}
                style={{ textAlign: align }}
                onValueChange={(v) => {
                  onChange(v.value * 1);
                  onChangeFn(v.value * 1);
                }}
                value={evaluateValue ? evaluateValue(value) : value}
                className={`w-100 border-0 input-line-heigth-cero input-home-cotizacion-type1bold ${extrasClasses}`}
                onPaste={(v) => {
                  onChange(v.value);
                  onChangeFn(v.value);
                }}
                placeholder={customPlaceHolder}
              />
            )}
            {!numerico && (
              <input
                id={inputProps.name}
                readOnly={disabled}
                className={classnames({
                  [`input-line-heigth-cero input-home-cotizacion-type1bold ${extrasClasses}`]: true,
                  "hide-arrows": hideArrows,
                })}
                ref={register(rules)}
                {...memoProps}
                defaultValue={defaultValue}
                onChange={(e) => {
                  onChange(e.target.value);
                  onChangeFn(e.target.value);
                }}
                onPaste={(v) => {
                  onChange(v.target.value);
                  onChangeFn(v.target.value);
                }}
              //ref={(ref) => console.log('REF: ', ref)}
              />
            )}
          </React.Fragment>
        );
      }}
    />
  );
};

export const Autocompletar = ({
  name,
  rules,
  type = "number",
  minLength = 1,
  maxLength = 10,
  completeMethod = () => { },
  suggestions = [],
  onSelectCodPostal = () => { },
  onUnselect = () => { },
  onChangeFn,
  dataKey,
  loading,
  disabled = false,
  defaultValue = null,
  placeholder = "SELECCIONE",
  loadingText = "BUSCANDO...",
  helpText,
  filter = true,
  emptyFilterMessage = "NO SE HA ENCONTRADO INFORMACIÓN",
  showClear = true,
  ...props
}) => {
  const { control } = useFormContext();

  const internalPlaceHolder = useMemo(
    () => (loading ? loadingText : placeholder),
    [loading, placeholder, loadingText]
  );

  const { focusRef, setRef } = useCustomRef(null);

  return (
    <React.Fragment>
      <Controller
        control={control}
        name={name}
        rules={rules}
        defaultValue={defaultValue}
        onFocus={focusRef}
        render={({ onChange, value, ref }) => {
          return (
            <AutoComplete
              showClear={showClear}
              minLength={minLength}
              maxlength={maxLength}
              forceSelection={true}
              onSelect={onSelectCodPostal}
              className='input__mask__mex'
              inputId={name}
              completeMethod={completeMethod}
              suggestions={suggestions}
              dataKey={dataKey}
              placeholder={internalPlaceHolder}
              disabled={loading || disabled}
              value={value ? value : ""}
              helpText={helpText}
              style={{ width: "100%" }}
              ref={setRef("focusInput")}
              emptyFilterMessage={emptyFilterMessage}
              onChange={(evt) => {
                onChange(evt.value);
                onChangeFn && onChangeFn(evt.value);
              }}
              onBlur={onUnselect}
            //panelStyle={{ overFlow: 'hidden' }}
            />
          );
        }}
      />
    </React.Fragment>
  );
};

export const DropDownFilterX = ({
  name,
  rules,
  showClear = true,
  onSelect = () => { },
  optionLabel = "label",
  optionValue = "value",
  options = [],
  onChangeFn = () => { },
  dataKey,
  loading,
  disabled = false,
  defaultValue = null,
  placeholder = "SELECCIONE",
  loadingText = "BUSCANDO...",
  helpText,
  filter = true,
  emptyFilterMessage = "NO SE HA ENCONTRADO INFORMACIÓN",
  ...props
}) => {
  const { control } = useFormContext();

  const internalPlaceHolder = useMemo(
    () => (loading ? loadingText : placeholder),
    [loading, placeholder, loadingText]
  );

  return (
    <React.Fragment>
      <Controller
        control={control}
        name={name}
        rules={rules}
        defaultValue={defaultValue}
        render={({ onChange, value, ref }) => {
          return (
            <Dropdown
              className='input__mask__mex'
              inputId={name}
              //showFilterClear={showClear}
              showClear={showClear}
              filterInputAutoFocus={false}
              optionLabel={optionLabel}
              optionValue={optionValue}
              options={options}
              filter={options.length > 6}
              dataKey={dataKey}
              placeholder={internalPlaceHolder}
              disabled={loading || disabled}
              value={value ? value : ""}
              helpText={helpText}
              style={{ width: "100%" }}
              //ref={setRef("focusInput")}
              ref={ref}
              emptyFilterMessage={emptyFilterMessage}
              onChange={(evt) => {
                onChange(evt.value ? evt.value : "");
                onChangeFn && onChangeFn(evt.value ? evt.value : "");
                onSelect(evt.value ? evt.value : "");
                //onSelect();
              }}

            //panelStyle={{ overFlow: 'hidden' }}
            />
          );
        }}
      />
    </React.Fragment>
  );
};

const customStylesDropDown = {
  menu: (provided, state) => ({
    ...provided,
    color: state.selectProps.menuColor,
    marginLeft: "-1em",
  }),
  placeholder: (provided, state) => ({
    ...provided,
    fontSize: "14px",
    fontWeigth: "bold",
    color: "#6c757d",
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    fontSize: "14px",
    fontWeigth: "bold",
  }),
  control: (styles) => ({
    ...styles,
    border: "none",
    boxShadow: "none",
  }),
  option: (styles, { data, isDisabled, isSelected }) => {
    const color = "#001871";
    return {
      ...styles,
      ":active": {
        ...styles[":active"],
        backgroundColor: !isDisabled && (isSelected ? data.color : color),
        color: "white",
      },
    };
  },
};

/**
 * @description Este componente de <Select/> no es sencible al undefined, no le toma como null
 * @param {*} param0
 * @returns
 */

export const DropDownFilter = ({
  name,
  rules,
  onSelect = () => { },
  optionLabel = "label",
  optionValue = "value",
  options = [],
  onChangeFn = null,
  dataKey,
  loading,
  disabled = false,
  defaultValue = null,
  placeholder = "SELECCIONE",
  loadingText = "BUSCANDO...",
  helpText,
  filter = true,
  emptyFilterMessage = "NO SE HA ENCONTRADO INFORMACIÓN",
  value,
  ...props
}) => {
  const { control } = useFormContext();
  const objectPath = require("object-path");

  const opciones = options?.map((option) => ({
    label: objectPath.get(option, optionLabel),
    value: objectPath.get(option, optionValue),
  }));

  const { focusRef, setRef } = useCustomRef(null);

  const internalPlaceHolder = useMemo(
    () => (loading ? loadingText : placeholder),
    [loading, placeholder, loadingText]
  );

  return (
    <React.Fragment>
      <Controller
        control={control}
        name={name}
        rules={rules}
        defaultValue={defaultValue}
        render={({ onChange, value, ref }) => {
          const label = opciones?.find(
            (item) => JSON.stringify(item?.value) === JSON.stringify(value)
          )?.label;
          let normalizado = {
            label,
            value,
          };

          let esValido = normalizado.label && normalizado.value;

          if (!esValido && !!defaultValue) {
            normalizado = {
              label: defaultValue.label,
              value: defaultValue,
            };
            esValido = true;
          }

          return (
            <React.Fragment>
              <Select
                className='w-100'
                id={name}
                defaultValue={defaultValue}
                isClearable={true}
                isSearchable={true}
                isDisabled={loading || disabled}
                isLoading={loading}
                noOptionsMessage={() => emptyFilterMessage}
                loadingMessage={() => {
                  return "Buscando...";
                }}
                value={esValido ? normalizado : internalPlaceHolder}
                name={name}
                options={opciones}
                ref={setRef("select")}
                onChange={(evt) => {
                  if (evt) {
                    onChange(evt?.value);
                    onChangeFn && onChangeFn(evt.value ? evt.value : "", name);
                    onSelect(evt.value ? evt.value : "");
                  } else {
                    onChange(null);
                    onChangeFn && onChangeFn(null);
                  }
                }}
                placeholder={internalPlaceHolder}
                styles={customStylesDropDown}
              />
            </React.Fragment>
          );
        }}
      />
    </React.Fragment>
  );
};
